import { classesData } from "../config/siteData";

const Classes = () => {
  return (
    <section id="classes" className="py-20 bg-orange-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
            Our <span className="text-purple-600">Classes</span>
          </h2>
        </div>
        
        <div className="space-y-12">
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <div className="text-center mb-8">
              <h3 className="text-3xl font-bold text-purple-600 mb-2">{classesData.acroHop.name}</h3>
              <p className="text-lg text-gray-600 mb-4">{classesData.acroHop.ages}</p>
              <div className="inline-block bg-purple-100 text-purple-800 px-4 py-2 rounded-lg font-semibold">
                {classesData.acroHop.time}
              </div>
            </div>
            <p className="text-gray-700 text-center text-lg">{classesData.acroHop.description}</p>
          </div>
          
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <h3 className="text-3xl font-bold text-center text-purple-600 mb-8">HIP-HOP CLASSES</h3>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {classesData.hipHopClasses.map((classItem, index) => (
                <div key={index} className="bg-gray-50 p-6 rounded-lg text-center hover:bg-gray-100 transition-colors">
                  <h4 className="text-xl font-bold text-gray-900 mb-3">{classItem.name}</h4>
                  <p className="text-purple-600 font-semibold mb-3">{classItem.ages}</p>
                  <div className="bg-purple-100 text-purple-800 px-3 py-2 rounded text-sm font-medium">
                    {classItem.time}
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="bg-gradient-to-r from-purple-600 to-teal-600 text-white p-8 rounded-xl shadow-lg">
            <div className="text-center">
              <h3 className="text-3xl font-bold mb-4">{classesData.competitive.name}</h3>
              <p className="text-xl leading-relaxed max-w-4xl mx-auto">
                {classesData.competitive.description}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Classes;